export default __webpack_public_path__ + "static/media/editor-active.0a102dbd.svg";